module.exports = __webpack_public_path__ + "img/2.1a62460e.png";